<div [formGroup]="timeRangeForm" class="input-group d-flex align-items-stretch flex-nowrap w-100 prime-input-group">
  <div class="flex-grow-1 min-w-0">
    <p-datepicker
      formControlName="fromTime"
      [timeOnly]="true"
      [hourFormat]="useMilitaryTime ? '24' : '12'"
      size="small"
      styleClass="w-100"
      (onBlur)="onFromTimeBlur()"
    ></p-datepicker>
  </div>

  <span class="input-group-text">to</span>

  <div class="flex-grow-1 min-w-0">
    <p-datepicker formControlName="toTime" [timeOnly]="true" [hourFormat]="useMilitaryTime ? '24' : '12'" size="small" styleClass="w-100" (onBlur)="onToTimeBlur()"></p-datepicker>
  </div>
</div>
